import { defineStore } from 'pinia';
import type { ShippingDetailsState } from '~~/types/vuex/ShippingDetails';

export const shippingDetailsStore = defineStore('shippingDetails', {
  state: () => ({ shippingDetails: {} as ShippingDetailsState['shippingDetails'] | null }),
  actions: {
    setShippingDetails(payload: ShippingDetailsState['shippingDetails'] | null) {

      this.shippingDetails = payload; 

    },
  },
});
